// src/utils/api.js

export const getTenantSlug = () => {
    const hostname = window.location.hostname; // e.g. sangam.localhost or tenant1.INTERESTNG.com

    if (hostname.includes('localhost')) {
        const parts = hostname.split('.');
        if (parts.length === 2) {
            return parts[0]; // sangam.localhost → sangam
        }
    } else {
        const parts = hostname.split('.');
        if (parts.length > 2) {
            return parts[0]; // tenant1.INTERESTNG.com → tenant1
        }
    }

    return null;
};

export const getApiBaseUrl = () => {
    const currentHostname = window.location.hostname;
    const currentProtocol = window.location.protocol;

    // If on React dev server (port 3000), point to Laravel backend on port 8000
    const apiPort = window.location.port === '3000' ? ':8000' : '';
    const path = process.env.REACT_APP_API_URL || '';

    return `${currentProtocol}//${currentHostname}${apiPort}${path}`;
};
